<div class="table">
    <table mat-table [dataSource]="spotsList">
        <ng-container matColumnDef="reserve">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef></th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element">
                <mat-icon *ngIf="element.isReserve === '1'" class="reserve-icon" svgIcon="reserve-icon"></mat-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="screenDate">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef>Date </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.dateEcran | date: 'dd/MM/yyyy'}} </td>
        </ng-container>
        
        <ng-container matColumnDef="product">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Produit </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{ element.productName }} ({{ element.productId }}) </td>
        </ng-container>

        <ng-container matColumnDef="productType">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Type Produit </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{ element.productType }} </td>
        </ng-container>

        <ng-container matColumnDef="campaign">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Campagne </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.campaignNum}} </td>
        </ng-container>

        <ng-container matColumnDef="advertiser">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Annonceur </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.advertiser}} </td>
        </ng-container>
        
        <ng-container matColumnDef="durspot">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Format </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.durSpot}} </td>
        </ng-container>

        <ng-container matColumnDef="emplaceCode">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> EP </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.emplaceCode}} </td>
        </ng-container>

        <ng-container matColumnDef="caInit">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> CA Init </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.caInit | number: '1.0-0'}} </td>
        </ng-container>

        <ng-container matColumnDef="caNet">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> CA Net </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.caNet | number: '1.0-0'}} </td>
        </ng-container>

        <ng-container matColumnDef="priceSector">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Grille </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.priceSector}} </td>
        </ng-container>

        <ng-container matColumnDef="abatt">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Abatts/Majos </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.abatt}} </td>
        </ng-container>

        <ng-container matColumnDef="utPlanning">
            <th class="header-cell-center-align font-ns" mat-header-cell *matHeaderCellDef> Planning </th>
            <td class="mat-cell-center-align" mat-cell *matCellDef="let element"> {{element.utPlanning}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="custom-header"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
</div>
